"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RequiredMinimumDistributionPageTwo;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _RequiredMinimumDistributionWizardCalc = require("./RequiredMinimumDistributionWizardCalc.config");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
var _utils = require("../../middleware/utils");
var _formik = require("formik");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
var _RequiredMinimumDistributionRefineModal = _interopRequireDefault(require("./RequiredMinimumDistributionRefineModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RequiredMinimumDistributionPageTwo(_ref) {
  var {
    apiData,
    fetchDataScienceResults,
    disclosureHandleClose,
    showDisclosure,
    refinementHandleClose,
    showRefinement,
    snapshot
  } = _ref;
  var resp = apiData === null || apiData === void 0 ? void 0 : apiData.data.result;
  var firstWithdrawalAmt = (0, _utils.numberToCurrencyString)(resp === null || resp === void 0 ? void 0 : resp.first_withdrawal_amt);
  var {
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var disclosureArray = ['This interactive calculator is a self-help tool and is not intended to provide financial advice or product recommendations. The results and explanations generated by this calculator are based upon, and will vary due to, your input and certain assumptions made by us. All projections are hypothetical in nature, do not reflect actual results, and are not guarantees of future results. MassMutual will assume no liability for the use of or reliance on this calculator. For a more accurate and detailed analysis specific to your circumstances, we encourage you to contact a qualified financial professional.', 'The information provided is not written or intended as specific tax or legal advice. MassMutual, its employees and representatives are not authorized to give tax or legal advice. Individuals are encouraged to seek advice from their own tax or legal counsel.', 'Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual) and its subsidiaries, C.M. Life Insurance Company (C. M. Life) and MML Bay State Life Insurance Company (MML Bay State), Springfield, MA 01111-0001. C.M. Life and MML Bay State are non-admitted in New York.'];
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, "Based on our calculations, you may be required to withdraw at least ".concat(firstWithdrawalAmt, " by April 1, ").concat(resp === null || resp === void 0 ? void 0 : resp.first_withdrawal_date, ". \n        If you do not withdraw at least this amount, you may have to pay an excise tax of up to 25% on the amount not distributed as required. "), /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: 'requiredDistribution',
    text: (0, _htmlReactParser.default)(_RequiredMinimumDistributionWizardCalc.popoverConfig.requiredDistributionInfo)
  }), " Check back when you get closer to your RMD starting age and we'll provide a more current calculation."), /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, {
    className: "calculators"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Text, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "calc--info-text row align-items-center",
    id: "requiredMinimumDistribution"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Required minimum distribution by April 1,", ' ', resp === null || resp === void 0 ? void 0 : resp.first_withdrawal_date)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "mm-text-right"
  }, /*#__PURE__*/_react.default.createElement("strong", null, firstWithdrawalAmt))))))), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    textArray: disclosureArray,
    handleClose: disclosureHandleClose,
    show: showDisclosure
  }), /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionRefineModal.default, {
    handleClose: closeAndResetRefinementModal,
    snapshot: snapshot,
    show: showRefinement,
    fetchDataScienceResults: fetchDataScienceResults,
    apiData: apiData
  }));
}